var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blog-toc-container"},[_c('h2',[_vm._v("目录")]),_c('Diractory',{attrs:{"list":_vm.newList},on:{"select":_vm.select}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }